let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8hwP3")).then(() => parcelRequire('aljge'));